import { locationCards, transportInfo, venueImage } from "@/mocks/festival";

export default function Location() {
  return (
    <section id="location" className="w-full bg-background-100 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <div className="reveal flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
          <div>
            <span className="text-xs tracking-[0.24em] text-primary-600">LOCATION</span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-tight text-foreground-950">
              축제장 오시는 길
            </h2>
            <p className="mt-4 max-w-xl text-sm md:text-base leading-relaxed text-foreground-600">
              입장초등학교 운동장에서 열립니다. 대중교통과 자가용 모두 편리하게 이용하실 수 있습니다.
            </p>
          </div>
          <a
            href="https://map.naver.com/p/search/입장초등학교"
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer inline-flex items-center gap-2 whitespace-nowrap rounded-full btn-gradient px-5 py-3 text-sm font-medium text-white self-start"
          >
            <i className="ri-map-pin-line"></i>지도에서 보기
          </a>
        </div>

        <div className="reveal grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-6">
          {locationCards.map((card) => (
            <div
              key={card.tag}
              className="rounded-lg border border-background-200 bg-background-50 px-5 py-5 md:px-6 md:py-6"
            >
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                {card.tag}
              </span>
              <strong className="mt-4 block font-heading text-lg md:text-xl text-foreground-950">
                {card.name}
              </strong>
              <p className="mt-2 text-sm text-foreground-600">{card.address}</p>
            </div>
          ))}
        </div>

        <div className="reveal reveal-delay-2 w-full overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="w-full h-[320px] md:h-[440px]">
            <iframe
              title="입장초등학교 위치 지도"
              src="https://www.google.com/maps?q=%EC%9E%85%EC%9E%A5%EC%B4%88%EB%93%B1%ED%95%99%EA%B5%90&z=15&output=embed"
              className="w-full h-full border-0"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {transportInfo.map((item, i) => (
            <div
              key={item.title}
              className={`reveal reveal-delay-${i + 1} flex gap-4 rounded-lg bg-background-50 border border-background-200 px-5 py-5`}
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xl text-primary-700">
                <i className={item.icon}></i>
              </span>
              <div>
                <strong className="block text-sm text-foreground-950">{item.title}</strong>
                <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 overflow-hidden rounded-lg">
          <div className="relative w-full h-[220px] md:h-[300px]">
            <img
              src={venueImage.src}
              alt={venueImage.alt}
              width={1200}
              height={800}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/70 to-primary-950/20"></div>
            <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-10 text-white">
              <span className="text-xs tracking-[0.2em] text-accent-300">VENUE</span>
              <strong className="mt-2 font-heading text-xl md:text-3xl">입장초등학교 운동장</strong>
              <span className="mt-2 text-xs md:text-sm text-white/80">
                메인무대 · 체험존 · 농특산물 판매장 · 먹거리존이 한자리에
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}